"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.splitAppKeys = exports.VOTE_REVIEW = exports.TRUSTYOU_REVIEWS_TYPE_ORDER = exports.TOP_PRIORITY_HOTELS_COUNT = exports.TOO_MANY_SOLD_OUT_PERCENT = exports.STORE_ACTIONS = exports.STORAGE_KEYS = exports.SPOKEN_LANGUAGES = exports.SIMILAR_HOTELS_ACTION_TYPES = exports.SEM_PAGE_QUERY_PARAM_VALUE = exports.SEARCH_RESULT_PAGINATION = exports.SEARCH_PROGRESS_STEPS = exports.SEARCH_PRIORITY = exports.SEARCH_POLLING_RESPONSE_STATUS = exports.SEARCH_POLLING_INTERVAL_IN_MILLI_SECONDS = exports.SEARCH_MINI_MAP_CONGIG = exports.ROOM_BASIS = exports.ROOMS_PACKAGES_FILTERS_DEFAULT_VALUE = exports.ROOMS_PACKAGES_FILTERS = exports.REVIEW_TEMPLATE_FIELD_TYPE = exports.REVIEWS_STORE_ACTIONS = exports.REVIEWS_SOURCES = exports.REVIEWS_CATEGORIES_IDS = exports.REVIEWS = exports.PRICE_CALENDAR_PWA_DAY_AROUND = exports.PRICE_CALENDAR_NO_PRICE = exports.PRICE_CALENDAR_DESKTOP_DAY_AROUND = exports.PREVIOUS_FILTER_SHOW_COUNT = exports.PREVIOUSFILTER_LOCALSTORAGE_LIMIT = exports.PAYMENT_STATUS = exports.PAX_TYPES = exports.PAX = exports.PACKAGES_POLLING_INTERVAL_IN_MILLI_SECONDS = exports.OLD_ROOM_BASIS = exports.MIN_DISCOUNT = exports.MINIMUM_ID_FOR_COVID_FACILITY_CATEGORIES = exports.MINIMUM_ID_FOR_COVID_FACILITIES = exports.MINIMUM_AVAILABLE_HOTEL_IN_AD = exports.MEAL_POLICY_MAX = exports.MAX_SIMILAR_HOTELS_COUNT = exports.MAX_RATING = exports.MAX_HOTELS_IN_SEM_PAGE = exports.MAX_FILTERS_PER_GROUP = exports.MAX_DISCOUNT = exports.MALDIVES_COUNTRY_CODE = exports.INVALID_COORDINATES = exports.INITIAL_PAGINATION_OBJECT = exports.HOTEL_SORT = exports.HOTEL_ORDER_END_USER_STATUS = exports.HOTEL_FILTERS_MAPPER = exports.HOTEL_FILTERS = exports.HOTEL_FACILITY_CATEGORIES = exports.HOTEL_FACILITIES = exports.HOTELS_RESPONSE_SORT_MAP = exports.HEALTH_AND_SAFETY_MINIMUM_ID = exports.FEW_DYNAMIC_HOTELS_PERCENT = exports.EXPEDIA_REVIEW_AVG_OVERALL_RATING_NAMES_HASH = exports.EXPEDIA_REVIEW_AVG_OVERALL_RATING_KEYS = exports.ERROR_CODES = exports.ERRORS_HASHMAP = exports.ENDPOINTS = exports.ELIGIBLE_PREVIOUS_FILTERS = exports.DISPLAY_TYPE = exports.DESCRIPTION_TITLES = exports.DEFAULT_BEDDING_TYPE_DROPDOWN = exports.CROSS_SELL_CONSTANT = exports.CROSS_SELL_APPlIED_PRICE = exports.COVID_MIN_CATEGORY_ID = exports.COVID_MIN_AMENITY_ID = exports.COVID_MAX_CATEGORY_ID = exports.COVID_MAX_AMENITY_ID = exports.COUNTRY_DISCOUNT = exports.COUNTRIES_WITH_DIFFERENT_RATES = exports.CART_PRODUCT_TYPES = exports.BREAKFAST_DESCRIPTIONS = exports.BOOKING_STATUS_MESSAGES = exports.BOOKING_STATUS = exports.BOOKING_METHODS = exports.BOOKING_HISTORY_CONSTANT = exports.APP_EVENTS = exports.API_BASE_URL = exports.APARTMENT_PROPERTY_TYPES = exports.ALMOSAFER_REVIEW_SORTBY = exports.ALMOSAFER_REVIEW_AVG_OVERALL_RATING_NAMES_HASH = exports.ALMOSAFER_REVIEW_AVG_OVERALL_RATING_KEYS = exports.ALMOSAFER_REVIEWS_RATING_ADJECTIVE = exports.AD_SOLUTION_PATH = exports.AD_CAROUSEL = exports.ADDONS_CONSTANT = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _constants = require("@tajawal/web-core-sdk-v2/lib/constants");
var _ERRORS_HASHMAP;
var API_BASE_URL = exports.API_BASE_URL = {
  CONFIG: 'https://config-api-dev-endpoint.tajawal.com',
  HOTELS: 'https://next-staging.almosafer.com'
};
var ENDPOINTS = exports.ENDPOINTS = {
  GET_POPULAR_CITIES: '/api/content/cms/mobile-jsons/{language}/almosafer/{pos}/json/popular-destinations.json',
  GENERATE_TOKEN: '/api/user/auth/token',
  AUTO_COMPLETE_DESTINATIONS: '/api/enigma/autocomplete?query={query}',
  GET_STATIC_HOTELS: '/api/enigma/v2/content/hotels/summaries',
  GET_STATIC_RESOURCES: '/api/enigma/hotel/lookup',
  GENERATE_SEARCH_ID: '/api/enigma/search/async',
  GET_SEARCH_RESULTS: '/api/enigma/search/poll/{sId}',
  GET_CAMPAIGNS: '/api/enigma/content/campaign?countryCode={countryCode}&destination={destination}',
  HOTEL_INFO: '/api/enigma/hotel-details/{hotelId}',
  GET_ATG_HOTEL_ID: '/api/enigma/lookups/tv/{tvHotelId}',
  HOTEL_REVIEWS: '/api/enigma/review-details/{hotelId}',
  GENERATE_MODIFY_SEARCH_POLLING_ID: '/api/enigma/v2/packages',
  GENERATE_PACKAGES_POLLING_ID: '/api/enigma/packages',
  GET_PACKAGES: '/api/enigma/packages/poll/{pId}',
  GET_ROOMS_TEMPLATES: '/api/enigma/templates/{templateIds}',
  SIMILAR_HOTELS_STATIC_CONTENT: '/api/enigma/content/similar-hotels/summaries?hotelId={hotelId}',
  SIMILAR_HOTELS_DYNAMIC_CONTENT: '/api/enigma/search/similar',
  SEM_PAGE_DESTINATIONS: 'https://tjwlhotelcms.s3.amazonaws.com/hotel_sem_images/top.json',
  ALMOSAFER_REVIEWS: 'https://tjwlhotelcms.s3.amazonaws.com/hotel_static_data/hotels/details/{atgHotelId}.json',
  HOTEL_CARD_IMAGES: 'https://tjwlhotelcms.s3.amazonaws.com/carousel/new/{placeId}.json',
  GET_REVIEW_TEMPLATE: '/api/review/template?token={token}',
  SUBMIT_REVIEW: '/api/review',
  HOTEL_RETRIEVE_REVIEWS: '/api/review/retrieve',
  EXPEDIA_HOTEL_RETRIEVE_REVIEWS: '/api/review/retrieve',
  HOTEL_REVIEW_VOTE: '/api/review/vote',
  HOTEL_REVIEW_FLAG: '/api/review/flag',
  HOTEL_REVIEW_TRANSLATE: '/api/review/translate?reviewId={reviewId}&translationLocale={locale}',
  EXPEDIA_HOTEL_REVIEW_TRANSLATE: '/api/review/translate',
  GET_CROSS_SELL_HOTELS: '/api/enigma/crosssell',
  CALCULATE_REWARD_BULK: '/api/loyalty/bulk-calculate-reward',
  CREATE_CART: '/api/enigma/cart',
  CREATE_SALE: '/api/enigma/sale',
  UPDATE_CART: '/api/enigma/cart',
  UPDATE_GUEST_DETAILS: '/api/enigma/cart/guest',
  UPDATE_GUEST_DETAILS_SALE: '/api/enigma/sale/{saleId}',
  GET_ADD_ONS: '/api/engima/add-on',
  UPDATE_ADDON_TO_CART: '/api/enigma/add-on/add',
  DELETE_ADDON_FROM_CART: '/api/enigma/add-on/delete',
  GET_ADD_ONS_MISC: '/api/addon/miscellaneous/v3/search',
  UPDATE_ADDON_TO_SALE: '/api/enigma/addon/miscellaneous/v3/add',
  DELETE_ADDON_FROM_SALE: '/api/enigma/addon/miscellaneous/v3/delete',
  GET_SALE_REWARDS: '/api/checkout/sale/{saleId}/calculate-reward',
  GET_CAROUSEL: '/api/enigma/carousel',
  REVIEW_CAROUSEL: '/api/review/carousel',
  REVIEWS: '/api/review/unified/retrieve',
  GET_PRICE_CALENDAR: '/api/enigma/v3/calendar-price'
};
var CART_PRODUCT_TYPES = exports.CART_PRODUCT_TYPES = {
  HOTEL: 'hotel',
  ADDON: 'addOn'
};
var SEARCH_PRIORITY = exports.SEARCH_PRIORITY = {
  HOTEL_ID: 'HOTEL_ID',
  HOTEL_GEO_COORDINATES: 'HOTEL_GEO_COORDINATES',
  LOCATION_PLACE_ID: 'LOCATION_PLACE_ID',
  QUERY: 'QUERY'
};
var SEARCH_POLLING_RESPONSE_STATUS = exports.SEARCH_POLLING_RESPONSE_STATUS = {
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED_SUCCESSFULLY: 'COMPLETED_SUCCESSFULLY',
  COMPLETED_WITH_FAILURE: 'COMPLETED_WITH_FAILURE',
  COMPLETED_WITH_TIMEOUT: 'COMPLETED_WITH_TIMEOUT'
};
var SEARCH_MINI_MAP_CONGIG = exports.SEARCH_MINI_MAP_CONGIG = {
  MIN_DISTANCE_BETWEEN_ORIGINAL_LOCATION: 1,
  MAX_DISTANCE_BETWEEN_ORIGINAL_LOCATION: 4,
  DISTANCE_BETWEEN_HOTELS: 1
};
var SEARCH_POLLING_INTERVAL_IN_MILLI_SECONDS = exports.SEARCH_POLLING_INTERVAL_IN_MILLI_SECONDS = 1500;
var PACKAGES_POLLING_INTERVAL_IN_MILLI_SECONDS = exports.PACKAGES_POLLING_INTERVAL_IN_MILLI_SECONDS = 1500;
var TOP_PRIORITY_HOTELS_COUNT = exports.TOP_PRIORITY_HOTELS_COUNT = 100;
var COUNTRIES_WITH_DIFFERENT_RATES = exports.COUNTRIES_WITH_DIFFERENT_RATES = ['EG', 'SA'];
var MAX_SIMILAR_HOTELS_COUNT = exports.MAX_SIMILAR_HOTELS_COUNT = 6;
var MAX_HOTELS_IN_SEM_PAGE = exports.MAX_HOTELS_IN_SEM_PAGE = 1500;
var MINIMUM_ID_FOR_COVID_FACILITIES = exports.MINIMUM_ID_FOR_COVID_FACILITIES = 80000;
var MINIMUM_ID_FOR_COVID_FACILITY_CATEGORIES = exports.MINIMUM_ID_FOR_COVID_FACILITY_CATEGORIES = 8000;
var MIN_DISCOUNT = exports.MIN_DISCOUNT = 5;
var MAX_DISCOUNT = exports.MAX_DISCOUNT = 70;
var MAX_RATING = exports.MAX_RATING = 10;
var COUNTRY_DISCOUNT = exports.COUNTRY_DISCOUNT = {
  EG: 10,
  SA: 10,
  AE: 10,
  TR: 10,
  GB: 10
};
var PRICE_CALENDAR_NO_PRICE = exports.PRICE_CALENDAR_NO_PRICE = 'no_price';
var PRICE_CALENDAR_DESKTOP_DAY_AROUND = exports.PRICE_CALENDAR_DESKTOP_DAY_AROUND = 6;
var PRICE_CALENDAR_PWA_DAY_AROUND = exports.PRICE_CALENDAR_PWA_DAY_AROUND = 2;
var INVALID_COORDINATES = exports.INVALID_COORDINATES = {
  lat: 0,
  lng: 0
};
var PAX = exports.PAX = {
  MIN_ADULTS_COUNT: 1,
  MIN_CHILDREN_COUNT: 0,
  MIN_INFANTS_COUNT: 0
};
var PAX_TYPES = exports.PAX_TYPES = {
  ADULT: 'ADT',
  CHILD: 'CHD'
};
var BREAKFAST_DESCRIPTIONS = exports.BREAKFAST_DESCRIPTIONS = ['Breakfast included', 'Continental Breakfast', 'شاملة للإفطار', 'إفطار كونتيننتال'];
var STORAGE_KEYS = exports.STORAGE_KEYS = {
  API_AUTH_TOKEN: 'API_AUTH_TOKEN',
  HOTEL_INFO: 'HOTEL_INFO',
  HOTEL_TRUSTYOU_REVIEWS: 'HOTEL_TRUSTYOU_REVIEWS',
  HOTEL_SEARCH_RESULT: 'HOTEL_SEARCH_RESULT',
  HOTEL_CART_DETAILS: 'HOTEL_CART_DETAILS',
  HOTEL_INFO_WITH_ROOM_AVAILABILITY: 'HOTEL_INFO_WITH_ROOM_AVAILABILITY',
  HOTEL_INFO_DETAILS: 'HOTEL_INFO_DETAILS',
  GUEST_DETAILS_FORM: 'GUEST_DETAILS_FORM',
  ORDER_DETAILS: 'ORDER_DETAILS',
  HOTEL_PACKAGESMAP: 'HOTEL_PACKAGESMAP',
  HOTEL_DISCOUNT: 'HOTEL_DISCOUNT_{hotelId}',
  VIEWED_HOTELS: 'VIEWED_HOTELS_{query}',
  SHOW_PRICE_PER_NIGHT: 'SHOW_PRICE_PER_NIGHT'
};
var REVIEWS_CATEGORIES_IDS = exports.REVIEWS_CATEGORIES_IDS = {
  ROOM: 11
};
var ROOMS_PACKAGES_FILTERS = exports.ROOMS_PACKAGES_FILTERS = {
  FREE_CANCELLATION: 'FREE_CANCELLATION',
  BREAKFAST_INCLUDED: 'BREAKFAST_INCLUDED',
  ALL_INCLUSIVE: 'ALL_INCLUSIVE',
  PAY_LATER: 'PAY_LATER',
  HAS_VIEW: 'HAS_VIEW',
  BEDDING_TYPE: 'BEDDING_TYPE'
};

// For below key will be text shown in UI and Value we will use for logic check

var DEFAULT_BEDDING_TYPE_DROPDOWN = exports.DEFAULT_BEDDING_TYPE_DROPDOWN = [{
  key: 'All',
  value: 'All',
  count: 0,
  translateKey: 'all'
}, {
  key: 'King bed',
  value: 'King bed',
  count: 0,
  translateKey: 'kingBed'
}, {
  key: 'Single bed',
  value: 'Single bed',
  count: 0,
  translateKey: 'singleBed'
}, {
  key: 'Twin beds',
  value: 'Twin bed',
  count: 0,
  translateKey: 'twinBed'
}, {
  key: 'Double bed',
  value: 'Double bed',
  count: 0,
  translateKey: 'doubleBed'
}, {
  key: 'Queen bed',
  value: 'Queen bed',
  count: 0,
  translateKey: 'queenBed'
}, {
  key: 'Sofa bed',
  value: 'Sofa bed',
  count: 0,
  translateKey: 'sofaBed'
}];
var ROOMS_PACKAGES_FILTERS_DEFAULT_VALUE = exports.ROOMS_PACKAGES_FILTERS_DEFAULT_VALUE = (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, ROOMS_PACKAGES_FILTERS.FREE_CANCELLATION, false), ROOMS_PACKAGES_FILTERS.BREAKFAST_INCLUDED, false), ROOMS_PACKAGES_FILTERS.ALL_INCLUSIVE, false), ROOMS_PACKAGES_FILTERS.PAY_LATER, false), ROOMS_PACKAGES_FILTERS.HAS_VIEW, false), ROOMS_PACKAGES_FILTERS.BEDDING_TYPE, [DEFAULT_BEDDING_TYPE_DROPDOWN[0].value]);
var OLD_ROOM_BASIS = exports.OLD_ROOM_BASIS = {
  // todo: used for guest details matching need to be removed after payment integration
  RO: 'Room Only RO',
  BB: 'Bed and Breakfast BB',
  HB: 'Half board HB',
  FB: 'Full board FB',
  CB: 'Continental Breakfast CB',
  AI: 'All Inclusive AI',
  IS: 'Iftar and Sohour',
  IO: 'Iftar'
};
var ROOM_BASIS = exports.ROOM_BASIS = {
  RO: 'RO',
  BB: 'BB',
  HB: 'HB',
  FB: 'FB',
  CB: 'CB',
  AI: 'AI',
  IS: 'IS',
  // Added for Iftar and Suhour
  IF: 'IF',
  // Added for Iftar
  SO: 'SO',
  // Sohour Included
  SB: 'SB',
  // Including Sohour or Breakfast (Guest choice),
  SOHOUR: 'Sohour',
  // In Future only SO code will be there and SOHOUR will be removed
  IFTAR: 'Iftar',
  // In Future only IF code will be there and IFTAR will be removed
  IFTAR_AND_SOHOUR: 'Iftar and Sohour',
  // In Future only IS code will be there and IFTAR_AND_SOHOUR will be removed
  SOHOUR_OR_BREAKFAST: 'Sohour or Breakfast',
  // In Future only SB code will be there and SOHOUR_OR_BREAKFAST will be removed
  iftar_and_sohour: 'Iftar and Sohour',
  'Iftar or Sohour': 'Iftar or Sohour',
  'Sohour or Breakfast (Guest choice)': 'Sohour or Breakfast (Guest choice)',
  'Sohour + Iftar or Breakfast + Lunch or Dinner (Guest choice)': 'Sohour + Iftar or Breakfast + Lunch or Dinner (Guest choice)',
  'Breakfast + Lunch + Dinner': 'Breakfast + Lunch + Dinner'
};
var MEAL_POLICY_MAX = exports.MEAL_POLICY_MAX = 2;
var SEARCH_RESULT_PAGINATION = exports.SEARCH_RESULT_PAGINATION = {
  FIRST_PAGE: 1,
  PAGE_SIZE: 40,
  MAX_PAGES: 20
};
var HOTEL_FILTERS = exports.HOTEL_FILTERS = {
  HOTEL_NAME: 'HOTEL_NAME',
  PRICE: 'PRICE',
  STAR_RATING: 'STAR_RATING',
  GUEST_RATING: 'GUEST_RATING',
  TOP_PICK: 'TOP_PICK',
  DISTRICT: 'DISTRICT',
  PROPERTY_AMENITIES: 'PROPERTY_AMENITIES',
  PROPERTY_TYPE: 'PROPERTY_TYPE',
  MEALS: 'MEALS',
  CHAIN: 'CHAIN',
  AVAILABLE_HOTELS: 'AVAILABLE_HOTELS',
  FREE_CANCELLATION: 'FREE_CANCELLATION',
  HEALTH_AND_SAFETY_MEASURES: 'HEALTH_AND_SAFETY_MEASURES',
  SMART_RATING_FILTERS: 'SMART_RATING_FILTERS',
  IN_POLICY_HOTELS: 'IN_POLICY_HOTELS',
  LANDMARKS: 'LANDMARKS'
};
var ELIGIBLE_PREVIOUS_FILTERS = exports.ELIGIBLE_PREVIOUS_FILTERS = [{
  name: HOTEL_FILTERS.STAR_RATING,
  position: 1,
  sortBy: 'value'
}, {
  name: HOTEL_FILTERS.GUEST_RATING,
  position: 2,
  sortBy: 'value'
}, {
  name: HOTEL_FILTERS.FREE_CANCELLATION,
  position: 3,
  sortBy: ''
}, {
  name: HOTEL_FILTERS.AVAILABLE_HOTELS,
  position: 4,
  sortBy: ''
}, {
  name: HOTEL_FILTERS.TOP_PICK,
  position: 5,
  sortBy: 'count'
}, {
  name: HOTEL_FILTERS.PROPERTY_AMENITIES,
  position: 6,
  sortBy: 'count'
}, {
  name: HOTEL_FILTERS.PROPERTY_TYPE,
  position: 7,
  sortBy: 'count'
}, {
  name: HOTEL_FILTERS.MEALS,
  position: 8,
  sortBy: 'value'
}, {
  name: HOTEL_FILTERS.DISTRICT,
  position: 9,
  sortBy: 'count'
}, {
  name: HOTEL_FILTERS.CHAIN,
  position: 10,
  sortBy: 'count'
}, {
  name: HOTEL_FILTERS.LANDMARKS,
  position: 11,
  sortBy: 'count'
}];
var HOTEL_FILTERS_MAPPER = exports.HOTEL_FILTERS_MAPPER = [{
  filterKey: 'PROPERTY_TYPE',
  urlKey: 'propertyTypes'
}, {
  filterKey: 'TOP_PICK',
  urlKey: 'favorites'
}, {
  filterKey: 'PROPERTY_AMENITIES',
  urlKey: 'propertyAmenities'
}, {
  filterKey: 'CHAIN',
  urlKey: 'chains'
}, {
  filterKey: 'DISTRICT',
  urlKey: 'districts'
}, {
  filterKey: 'STAR_RATING',
  urlKey: 'starRatings'
}];
var MAX_FILTERS_PER_GROUP = exports.MAX_FILTERS_PER_GROUP = 16;
var TOO_MANY_SOLD_OUT_PERCENT = exports.TOO_MANY_SOLD_OUT_PERCENT = 0.4;
var FEW_DYNAMIC_HOTELS_PERCENT = exports.FEW_DYNAMIC_HOTELS_PERCENT = 0; // To show even if hotels are more than or equal to 1

var SEARCH_PROGRESS_STEPS = exports.SEARCH_PROGRESS_STEPS = {
  SKELETON: 'SKELETON',
  STATIC_CONTENT: 'STATIC_CONTENT',
  DYNAMIC_CONTENT: 'DYNAMIC_CONTENT',
  POLLING_COMPLETED: 'POLLING_COMPLETED'
};
var HOTEL_SORT = exports.HOTEL_SORT = {
  RECOMMENDATION: 'RECOMMENDATION',
  LOWEST_PRICE: 'LOWEST_PRICE',
  GUEST_RATING: 'GUEST_RATING',
  DISTANCE: 'DISTANCE'
};
var REVIEWS_STORE_ACTIONS = exports.REVIEWS_STORE_ACTIONS = {
  CAROUSEL_REVIEWS: 'CAROUSEL_REVIEWS',
  GET_REVIEWS: 'GET_REVIEWS'
};
var HOTELS_RESPONSE_SORT_MAP = exports.HOTELS_RESPONSE_SORT_MAP = {
  distance: HOTEL_SORT.DISTANCE,
  priority: HOTEL_SORT.RECOMMENDATION
};
var HOTEL_FACILITY_CATEGORIES = exports.HOTEL_FACILITY_CATEGORIES = {
  GENERAL: 20,
  ACCESSIBILITY: 13
};
var HOTEL_FACILITIES = exports.HOTEL_FACILITIES = {
  SMOKING: 95,
  NON_SMOKING: 88,
  WHEELCHAIR: 4,
  ACCESSIABLE_ROOM: 5
};
var APP_EVENTS = exports.APP_EVENTS = {
  HOTELS: {
    HOTEL_SEARCH: 'hotel.search',
    HOTEL_SELECT: 'hotel.select',
    HOTEL_SEARCH_DETAIL: 'hotel.search-details',
    HOTEL_SEARCH_SELECT: 'hotel.search-select',
    HOTEL_RESULTS: 'hotel.results',
    HOTEL_BOOKING: 'hotel.booking'
  }
};
var TRUSTYOU_REVIEWS_TYPE_ORDER = exports.TRUSTYOU_REVIEWS_TYPE_ORDER = ['14', '171', '15', '333', '11', '244', '11b', '13', '15e', '15m', '22a'];
var ERROR_CODES = exports.ERROR_CODES = {
  MISSING_REQUIRED_PARAMETER: 1001,
  INVALID_SEARCH_REQUEST: 1004,
  INVALID_HOTEL_ID: 1005,
  INVALID_PACKAGE_REQUEST: 1006,
  PACKAGES_INVALID_VALUE: 1007,
  INVALID_AVAILABILTY_SYNC_REQUEST: 1008,
  INVALID_AVAILABILTY_ASYNC_REQUEST: 1009,
  SEARCH_POLLING_INVALID_VALUE: 1010,
  SERVICE_ERROR: 1011,
  SERVICE_NOT_AVAILABLE: 1013,
  INVALID_PLACE_ID: 1014,
  INVALID_BOOKING_DATES: 1015,
  INVALID_NUMBER_OF_ROOMS: 1016,
  INVALID_LONG: 1017,
  INVALID_LAT: 1018,
  INVALID_RADIUS: 1019,
  INVALID_CHECK_IN_DATE: 1020,
  INVALID_CHECK_OUT_DATE: 1021,
  INVALID_NUMBER_OF_BOOKING_DAYS: 1022,
  INVALID_NUMBER_OF_ADULTS_MIN: 1023,
  INVALID_NUMBER_OF_ADULTS_MAX: 1024,
  INVALID_KIDS_AGE: 1025,
  INVALID_PAGE_ID: 1026,
  INVALID_LAST_MIN_BOOKING: 1029,
  INVALID_CART_ID: 1035,
  REVIEW_TOKEN_EXPIRED: 2002
};
var SEM_PAGE_QUERY_PARAM_VALUE = exports.SEM_PAGE_QUERY_PARAM_VALUE = 'SEM';
var ERRORS_HASHMAP = exports.ERRORS_HASHMAP = (_ERRORS_HASHMAP = {}, (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_ERRORS_HASHMAP, ERROR_CODES.MISSING_REQUIRED_PARAMETER, {
  errorCode: 400,
  statusCode: 'MISSING_REQUIRED_PARAMETER',
  titleEn: "Sorry, we can't find any properties in “destination name”",
  titleAr: 'عذرا، لم نستطع إيجاد فنادق أو شقق في “اسم الوجهة” ب',
  bodyTextEn: 'Please try entering a different destination.',
  bodyTextAr: 'من فضلك جرب إدخال وجهة مختلفة',
  primaryActionLabelEn: 'Change destination',
  primaryActionLabelAr: 'تعديل الوجهة',
  itShould: 'should direct to Destination input field'
}), ERROR_CODES.INVALID_SEARCH_REQUEST, {
  errorCode: 400,
  statusCode: 'INVALID_SEARCH_REQUEST',
  titleEn: 'Search was interrupted',
  titleAr: 'لم تتم عملية البحث بشكل كامل',
  bodyTextEn: 'Results were not completely loaded. Please refresh page',
  bodyTextAr: 'لم يتم تحميل جميع النتائج. يرجى إعادة المحاولة',
  primaryActionLabelEn: 'Refresh results',
  primaryActionLabelAr: 'تحديث النتائج',
  secondaryActionLabelEn: 'Back to home',
  secondaryActionLabelAr: 'الرجوع للصفحة الرئيسية'
}), ERROR_CODES.INVALID_HOTEL_ID, {
  errorCode: 400,
  statusCode: 'INVALID_HOTEL_ID',
  bodyTextEn: null,
  bodyTextAr: null
}), ERROR_CODES.INVALID_PACKAGE_REQUEST, {
  errorCode: 400,
  statusCode: 'INVALID_PACKAGE_REQUEST',
  bodyTextEn: null,
  bodyTextAr: null
}), ERROR_CODES.PACKAGES_INVALID_VALUE, {
  errorCode: 400,
  statusCode: 'INVALID_VALUE',
  bodyTextEn: null,
  bodyTextAr: null
}), ERROR_CODES.INVALID_AVAILABILTY_SYNC_REQUEST, {
  errorCode: 400,
  statusCode: 'INVALID_AVAILABILTY_SYNC_REQUEST',
  bodyTextEn: null,
  bodyTextAr: null
}), ERROR_CODES.INVALID_AVAILABILTY_ASYNC_REQUEST, {
  errorCode: 400,
  statusCode: 'INVALID_AVAILABILTY_ASYNC_REQUEST',
  titleEn: 'Search was interrupted',
  titleAr: 'لم تتم عملية البحث بشكل كامل',
  bodyTextEn: 'Results were not completely loaded. Please refresh page',
  bodyTextAr: 'لم يتم تحميل جميع النتائج. يرجى إعادة المحاولة',
  primaryActionLabelEn: 'Refresh results',
  primaryActionLabelAr: 'تحديث النتائج',
  secondaryActionLabelEn: 'Back to home',
  secondaryActionLabelAr: 'الرجوع للصفحة الرئيسية'
}), ERROR_CODES.SEARCH_POLLING_INVALID_VALUE, {
  errorCode: 400,
  statusCode: 'INVALID_VALUE',
  titleEn: 'Search was interrupted',
  titleAr: 'لم تتم عملية البحث بشكل كامل',
  bodyTextEn: 'Results were not completely loaded. Please refresh page',
  bodyTextAr: 'لم يتم تحميل جميع النتائج. يرجى إعادة المحاولة',
  primaryActionLabelEn: 'Refresh results',
  primaryActionLabelAr: 'تحديث النتائج',
  secondaryActionLabelEn: 'Back to home',
  secondaryActionLabelAr: 'الرجوع للصفحة الرئيسية'
}), ERROR_CODES.SERVICE_ERROR, {
  errorCode: 500,
  statusCode: 'SERVICE_ERROR',
  titleEn: 'Sorry, the website is currently under maintenance',
  titleAr: 'عذرا، الموقع غير متاح في الوقت الحالي',
  bodyTextEn: 'This might take some time to fix. Please try again later',
  bodyTextAr: 'قد يستغرق الإصلاح بعض الوقت. من فضلك حاول مرة أخرى لاحقا',
  primaryActionLabelEn: 'Back to home',
  primaryActionLabelAr: 'الرجوع للصفحة الرئيسية'
}), ERROR_CODES.SERVICE_NOT_AVAILABLE, {
  errorCode: 404,
  statusCode: 'SERVICE_NOT_AVAILABLE',
  titleEn: 'Sorry, the website is currently under maintenance',
  titleAr: 'عذرا، الموقع غير متاح في الوقت الحالي',
  bodyTextEn: 'This might take some time to fix. Please try again later',
  bodyTextAr: 'قد يستغرق الإصلاح بعض الوقت. من فضلك حاول مرة أخرى لاحقا',
  primaryActionLabelEn: 'Back to home',
  primaryActionLabelAr: 'الرجوع للصفحة الرئيسية'
}), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_ERRORS_HASHMAP, ERROR_CODES.INVALID_PLACE_ID, {
  errorCode: 400,
  statusCode: 'INVALID_PLACE_ID',
  bodyTextEn: null,
  bodyTextAr: null
}), ERROR_CODES.INVALID_BOOKING_DATES, {
  errorCode: 400,
  statusCode: 'INVALID_BOOKING_DATES',
  bodyTextEn: 'CheckIn / Checkout dates incorrect',
  bodyTextAr: 'تواريخ الدخول / المغادرة غير صحيحه'
}), ERROR_CODES.INVALID_NUMBER_OF_ROOMS, {
  errorCode: 400,
  statusCode: 'INVALID_NUMBER_OF_ROOMS',
  titleEn: 'Search was interrupted',
  titleAr: 'لم تتم عملية البحث بشكل كامل',
  bodyTextEn: 'You have exceeded the maximum number of rooms, the maximum number for rooms is 4',
  bodyTextAr: 'لقد تجاوزت الحد الأقصى لعدد الغرف ، والحد الأقصى لعدد الغرف هو 4',
  primaryActionLabelEn: 'Modify Search',
  primaryActionLabelAr: 'تعديل البحث'
}), ERROR_CODES.INVALID_LONG, {
  errorCode: 400,
  statusCode: 'INVALID_LONG_LAT',
  bodyTextEn: null,
  bodyTextAr: null
}), ERROR_CODES.INVALID_LAT, {
  errorCode: 400,
  statusCode: 'INVALID_QUERY',
  bodyTextEn: null,
  bodyTextAr: null
}), ERROR_CODES.INVALID_RADIUS, {
  errorCode: 400,
  statusCode: 'INVALID_RADIUS',
  bodyTextEn: null,
  bodyTextAr: null
}), ERROR_CODES.INVALID_CHECK_IN_DATE, {
  errorCode: 400,
  statusCode: 'INVALID_CHECK_IN_DATE',
  titleEn: 'Dates are expired',
  titleAr: 'انتهت التواريخ',
  bodyTextEn: "Sorry, the dates you entered are expired,\n    Choose different dates to view hotel options",
  bodyTextAr: "\u0639\u0641\u0648\u064B\u0627 \u060C \u0627\u0646\u062A\u0647\u062A \u0635\u0644\u0627\u062D\u064A\u0629 \u0627\u0644\u062A\u0648\u0627\u0631\u064A\u062E \u0627\u0644\u062A\u064A \u0623\u062F\u062E\u0644\u062A\u0647\u0627 \u060C \u0627\u062E\u062A\u0631 \u062A\u0648\u0627\u0631\u064A\u062E \u0645\u062E\u062A\u0644\u0641\u0629 \u0644\u0639\u0631\u0636 \u062E\u064A\u0627\u0631\u0627\u062A \u0627\u0644\u0641\u0646\u062F\u0642",
  primaryActionLabelEn: 'Change dates',
  primaryActionLabelAr: 'تغيير التواريخ',
  secondaryActionLabelEn: 'Continue anyway',
  secondaryActionLabelAr: 'واصل على أي حال'
}), ERROR_CODES.INVALID_CHECK_OUT_DATE, {
  errorCode: 400,
  statusCode: 'INVALID_CHECK_OUT_DATE',
  titleEn: 'wrong CheckOut date',
  titleAr: 'تاريخ المغادرة غير صحيح',
  bodyTextEn: 'CheckOut date must be after checkIn date',
  bodyTextAr: 'يجب أن يكون تاريخ المغادرة بعد تاريخ تسجيل الوصول',
  primaryActionLabelEn: 'Change dates',
  primaryActionLabelAr: 'تغيير التواريخ'
}), ERROR_CODES.INVALID_NUMBER_OF_BOOKING_DAYS, {
  errorCode: 400,
  statusCode: 'INVALID_NUMBER_OF_BOOKING_DAYS',
  titleEn: 'invalid number of booking days',
  titleAr: 'عدد غير صحيح من أيام الحجز',
  bodyTextEn: 'you have exceeded the maximum number of days that you can book, the maximum number is 28 days',
  bodyTextAr: 'لقد تجاوزت الحد الأقصى لعدد الأيام التي يمكنك حجزها ، والحد الأقصى هو 28 يومًا',
  primaryActionLabelEn: 'Change dates',
  primaryActionLabelAr: 'تغيير التواريخ'
}), ERROR_CODES.INVALID_NUMBER_OF_ADULTS_MIN, {
  errorCode: 400,
  statusCode: 'INVALID_NUMBER_OF_ADULTS_MIN',
  titleEn: 'Search was interrupted',
  titleAr: 'لم تتم عملية البحث بشكل كامل',
  bodyTextEn: 'Adults count must be greater than zero',
  bodyTextAr: 'يجب أن يكون عدد البالغين أكبر من الصفر',
  primaryActionLabelEn: 'Modify search',
  primaryActionLabelAr: 'تعديل البحث'
}), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_ERRORS_HASHMAP, ERROR_CODES.INVALID_NUMBER_OF_ADULTS_MAX, {
  errorCode: 400,
  statusCode: 'INVALID_NUMBER_OF_ADULTS_MAX',
  titleEn: 'Number of guests exceeded',
  titleAr: 'تم تجاوز الحد الأقصى للنزلاء',
  bodyTextEn: 'The maximum number of guests in a room is 8. Please modify search and try again',
  bodyTextAr: 'الحد الأقصى للنزلاء فى الغرفة الواحدة هو 8. يرجى تعديل البحث',
  primaryActionLabelEn: 'Modify search',
  primaryActionLabelAr: 'تعديل البحث'
}), ERROR_CODES.INVALID_KIDS_AGE, {
  errorCode: 400,
  statusCode: 'INVALID_KIDS_AGE',
  titleEn: 'Search was interrupted',
  titleAr: 'لم تتم عملية البحث بشكل كامل',
  bodyTextEn: 'Kids Age must be between 0-11',
  bodyTextAr: 'يجب أن يكون عمر الأطفال بين 0-11',
  primaryActionLabelEn: 'Modify search',
  primaryActionLabelAr: 'تعديل البحث'
}), ERROR_CODES.INVALID_PAGE_ID, {
  errorCode: 400,
  statusCode: 'INVALID_PAGE_ID',
  bodyTextEn: null,
  bodyTextAr: null
}), ERROR_CODES.INVALID_LAST_MIN_BOOKING, {
  errorCode: 400,
  statusCode: 'INVALID_LAST_MIN_BOOKING',
  bodyTextEn: null,
  bodyTextAr: null
}), ERROR_CODES.INVALID_CART_ID, {
  errorCode: 400,
  statusCode: 'INVALID_CART_ID',
  titleEn: 'the required booking is not exist',
  titleAr: 'معرف الحجز المطلوب غير موجود',
  bodyTextEn: 'the required package ID is not exiist or expired, package is boooking process usually expire in 25 min',
  bodyTextAr: 'معرف الحزمة المطلوب غير موجود أو منتهي الصلاحية ، تنتهي عملية الحجز عادةً في غضون 25 دقيقة',
  primaryActionLabelEn: 'Back to home',
  primaryActionLabelAr: 'الرجوع للصفحة الرئيسية'
}), ERROR_CODES.REVIEW_TOKEN_EXPIRED, {
  errorCode: 400,
  statusCode: 'REVIEW_TOKEN_EXPIRED',
  titleEn: 'Review already submitted',
  titleAr: 'تم إرسال التقييم',
  bodyTextEn: 'You have already submitted a review for this hotel.',
  bodyTextAr: 'لقد قمت بتقييم هذا الفندق مسبقاً',
  primaryActionLabelEn: 'Home page',
  primaryActionLabelAr: 'الصفحة الرئيسية'
}));
var ALMOSAFER_REVIEWS_RATING_ADJECTIVE = exports.ALMOSAFER_REVIEWS_RATING_ADJECTIVE = {
  SUPERB: 'Superb',
  EXCELLENT: 'Excellent',
  VERY_GOOD: 'Very good',
  GOOD: 'Good',
  FAIR: 'Fair'
};
var HEALTH_AND_SAFETY_MINIMUM_ID = exports.HEALTH_AND_SAFETY_MINIMUM_ID = 8000;
var COVID_MIN_AMENITY_ID = exports.COVID_MIN_AMENITY_ID = 8000;
var COVID_MAX_AMENITY_ID = exports.COVID_MAX_AMENITY_ID = 8025;
var COVID_MIN_CATEGORY_ID = exports.COVID_MIN_CATEGORY_ID = 800;
var COVID_MAX_CATEGORY_ID = exports.COVID_MAX_CATEGORY_ID = 804;
var ALMOSAFER_REVIEW_AVG_OVERALL_RATING_KEYS = exports.ALMOSAFER_REVIEW_AVG_OVERALL_RATING_KEYS = ['location', 'cleanliness', 'valueForMoney', 'service', 'rooms', 'amenities'];
var ALMOSAFER_REVIEW_AVG_OVERALL_RATING_NAMES_HASH = exports.ALMOSAFER_REVIEW_AVG_OVERALL_RATING_NAMES_HASH = {
  location: 'Location',
  cleanliness: 'Cleanness',
  valueForMoney: 'Value for money',
  service: 'Service',
  rooms: 'Rooms',
  amenities: 'Amenities'
};
var EXPEDIA_REVIEW_AVG_OVERALL_RATING_KEYS = exports.EXPEDIA_REVIEW_AVG_OVERALL_RATING_KEYS = ['amenities', 'cleanliness', 'comfort', 'condition', 'location', 'neighborhood', 'service', 'value', 'quality'];
var REVIEWS_SOURCES = exports.REVIEWS_SOURCES = {
  ALMOSAFER: 'direct',
  EXPEDIA: 'expedia'
};
var EXPEDIA_REVIEW_AVG_OVERALL_RATING_NAMES_HASH = exports.EXPEDIA_REVIEW_AVG_OVERALL_RATING_NAMES_HASH = {
  amenities: 'Amenities',
  cleanliness: 'Cleanness',
  comfort: 'Comfort',
  condition: 'Condition',
  location: 'Location',
  neighborhood: 'Neighborhood',
  service: 'Service',
  value: 'Value',
  quality: 'Quality'
};
var VOTE_REVIEW = exports.VOTE_REVIEW = {
  HELPFUL: 'helpful',
  UNHELPFUL: 'unhelpful'
};
var ALMOSAFER_REVIEW_SORTBY = exports.ALMOSAFER_REVIEW_SORTBY = [{
  key: 'Newest',
  value: 'Newest'
}, {
  key: 'Oldest',
  value: 'Oldest'
}, {
  key: 'HighestRating',
  value: 'Highest Rated'
}, {
  key: 'LowestRating',
  value: 'Lowest Rated'
}];
var INITIAL_PAGINATION_OBJECT = exports.INITIAL_PAGINATION_OBJECT = {
  nextPageUrl: ''
};
var CROSS_SELL_CONSTANT = exports.CROSS_SELL_CONSTANT = {
  GENERAL_KEY: 'cs_flight',
  FLIGHT_CONFIRMATION_EVENT_CATEGORY: 'Flight confirmation',
  FLIGHT_MANAGE_BOOKING_EVENT_CATEGORY: 'Flight details'
};
var CROSS_SELL_APPlIED_PRICE = exports.CROSS_SELL_APPlIED_PRICE = 'CS';
var HOTEL_ORDER_END_USER_STATUS = exports.HOTEL_ORDER_END_USER_STATUS = {
  CONFIRMED: 'CONFIRMED',
  CONFIRMING_WITH_HOTEL: 'CONFIRMING_WITH_HOTEL',
  PAYMENT_PENDING: 'PAYMENT_PENDING',
  CANCELLED_PAY_NOW: 'CANCELLED_PAY_NOW',
  CANCELLED_PAY_LATER: 'CANCELLED_PAY_LATER',
  NOT_CONFIRMED: 'NOT_CONFIRMED',
  STAY_COMPLETED: 'STAY_COMPLETED'
};
var PAYMENT_STATUS = exports.PAYMENT_STATUS = {
  AUTHORIZED: 78,
  AUTHORIZED_WITH_INSTALLMENTS: 80,
  PENDING: 71
};
var BOOKING_STATUS = exports.BOOKING_STATUS = {
  FAILURE: 91,
  CANCELLED: 94,
  SUCCESS: 58,
  PENDING: 71
};
var BOOKING_STATUS_MESSAGES = exports.BOOKING_STATUS_MESSAGES = {
  // happens for pay now and pay later
  CONFIRMED: 'CONFIRMED',
  // happens when a user called out agents and cancelled from hub || in pay later when a user doesn't pay
  CANCELLED: 'CANCELLED',
  // happens only in pay later before paying
  UNAVAILABLE: 'UNAVAILABLE',
  // happens when pay now if we don't have a confirmation number yet || in pay later if there are available rooms
  PROCESSING: 'PROCESSING'
};
var BOOKING_METHODS = exports.BOOKING_METHODS = {
  PAY_NOW: 'paynow',
  PAY_LATER: 'paylater'
};

/*
 * Property types that are considered as apartments
 * 'Apartment', 'Aparthotel', 'Property', 'Villa', 'Private vacation home', 'Guesthouse','Residence'
 * **/
var APARTMENT_PROPERTY_TYPES = exports.APARTMENT_PROPERTY_TYPES = [11, 13, 15, 16, 20, 33, 35];
var ADDONS_CONSTANT = exports.ADDONS_CONSTANT = {
  SELECTION_TYPE: {
    SINGLE: 'single',
    MULTIPLE: 'multiple',
    BOOKING: 'booking'
  },
  SHOW_TYPE: {
    // fixed, quantity, head
    FIXED: 'fixed',
    QUANTITY: 'quantity',
    HEAD: 'head'
  }
};

/*
This is a constant for booking history AB test 'hotels_booking_history'
*/
var BOOKING_HISTORY_CONSTANT = exports.BOOKING_HISTORY_CONSTANT = {
  dubai: 35,
  cairo: 35,
  mecca: 35,
  riyadh: 20,
  istanbul: 20,
  manama: 20,
  london: 20
};
var splitAppKeys = exports.splitAppKeys = {
  staging: 'b6ff7810-8dca-11ee-b131-ba51abd45a07',
  prod: 'b6e81f80-8dca-11ee-b131-ba51abd45a07'
};
var SIMILAR_HOTELS_ACTION_TYPES = exports.SIMILAR_HOTELS_ACTION_TYPES = {
  GET_STATIC_HOTELS: 'GET_STATIC_HOTELS',
  GET_DYNAMIC_HOTELS: 'GET_DYNAMIC_HOTELS'
};
var AD_SOLUTION_PATH = exports.AD_SOLUTION_PATH = {
  APP: '/internal/hotels',
  APP_PROXY_PATH: "/internal/hotels".concat(_constants.HOSTS.AD_SOLUTION.PATHNAME)
};
var MALDIVES_COUNTRY_CODE = exports.MALDIVES_COUNTRY_CODE = 'MV';
var PREVIOUSFILTER_LOCALSTORAGE_LIMIT = exports.PREVIOUSFILTER_LOCALSTORAGE_LIMIT = 15;
var PREVIOUS_FILTER_SHOW_COUNT = exports.PREVIOUS_FILTER_SHOW_COUNT = 5;
var MINIMUM_AVAILABLE_HOTEL_IN_AD = exports.MINIMUM_AVAILABLE_HOTEL_IN_AD = 3;
var AD_CAROUSEL = exports.AD_CAROUSEL = 'AD_CAROUSEL';
var REVIEW_TEMPLATE_FIELD_TYPE = exports.REVIEW_TEMPLATE_FIELD_TYPE = {
  LIST: 'List',
  RADIO: 'RadioButton',
  TEXTBOX: 'TextBox',
  TEXTAREA: 'TextArea',
  SUB_TYPE: {
    NATIONALITY: 'nationality',
    GUIDELINE: 'guideline'
  }
};
var SPOKEN_LANGUAGES = exports.SPOKEN_LANGUAGES = {
  AR: 'arabic'
};
var DISPLAY_TYPE = exports.DISPLAY_TYPE = {
  LOCATION: 'Location'
};
var DESCRIPTION_TITLES = exports.DESCRIPTION_TITLES = {
  SPOKEN_LANGUAGES: 'Spoken Languages',
  LOCATION: 'Location',
  GENERAL_DESCRIPTION: 'General description',
  DINING: 'Dining',
  ROOMS: 'Rooms',
  AMENITIES: 'Amenities',
  BUSINESS_OTHER_AMENITIES: 'Business, and other amenities',
  ATTRACTIONS: 'Attractions'
};
var STORE_ACTIONS = exports.STORE_ACTIONS = {
  MISC_STORE: {
    GET_MISC: 'GET_MISC',
    UPDATE_SALE_MISC: 'UPDATE_SALE_MISC'
  },
  // TODO - Once Guest detail update is remove from sale store - read from core sdk
  SALE_STORE: {
    CREATE_SALE: 'CREATE_SALE',
    FETCH_SALE: 'FETCH_SALE',
    UPDATE_SALE: 'UPDATE_SALE',
    UPDATE_GUEST_DETAILS: 'UPDATE_GUEST_DETAILS'
  }
};
var REVIEWS = exports.REVIEWS = {
  FILTER_TYPE: {
    TAGS: 'TAGS',
    TRAVEL_TYPE: 'TRAVEL_TYPE'
  }
};